export default {
      id: "plus-usage",
      viewBox: "0 0 13 12",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#plus",
      toString: function () {
        return this.url;
      }
    }